import React from "react";
import { Outlet } from "react-router-dom";
import { Box, Container } from "@mui/material";
import AdminTopBar from "../NavBar";

export default function AdminLayout() {
  return (
    <Box sx={{ minHeight: "100vh" }}>
      <AdminTopBar />
      <Container maxWidth="xl" sx={{ py: 3 }}>
        <Outlet />
      </Container>
    </Box>
  );
}
